module.exports = __webpack_public_path__ + "static/media/visionred.81c4f39d.png";